import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchPopins } from '../../actions/tenantStats';
import Logger from '../../util/Logger';
import User from '../../models/User';
import PopinSummary from '../../models/PopinSummary';
import { AnalyticsCardHeader } from './AnalyticsCardHeader';
import SearchBox from '../shared/SearchBox';
import './PopinsBreakdown.css';
import popSearch from '../../services/pop-search';
import { PopinSorts } from '../../util/PopinSorts';
import popinConvo from '../../images/popin-convo-outline.png';
import Tenant from '../../models/Tenant';
import LoadingAndPulse from '../shared/LoadingAndPulse.jsx';
import { UserAvatar } from '../shared/UserAvatar';
import '../shared/UserAvatar.css';
import Tooltip from '../shared/Tooltip';
import { arrowDownIcon, arrowUpIcon } from '../../constants';
import ErrorAndRefresh from '../shared/ErrorAndRefresh';
import { handleError } from '../../util/Errors';
import EmptyState from '../shared/EmptyState';
import EmptyStateIcon from '../../images/popins_empty_state.svg';
import DateTime from '../../models/DateTime';
import { EnterpriseAnalytics } from '../../analytics/EnterpriseAnalytics';

const Sorts = {
  START_TIME_ASCENDING: 'start_time',
  START_TIME_DESCENDING: 'start_time_reverse',
  NAME_ASCENDING: 'name',
  NAME_DESCENDING: 'name_reverse',
  EMAIL_ASCENDING: 'email',
  EMAIL_DESCENDING: 'email_reverse',
  USE_CASE_ASCENDING: 'use_case',
  USE_CASE_DESCENDING: 'use_case_reverse',
  USERS_ASCENDING: 'users',
  USERS_DESCENDING: 'users_reverse',
  ACTIVITIES_ASCENDING: 'activities',
  ACTIVITIES_DESCENDING: 'activities_reverse'
};

class PopinsBreakdown extends Component {

  handleSortByStartTime = () => {
    const newSort = !this.state.startTimeSortReversed;
    EnterpriseAnalytics.sortsPopinsByStartTime();
    this.setState({
      startTimeSortReversed: newSort,
      activeSort: newSort ? Sorts.START_TIME_DESCENDING : Sorts.START_TIME_ASCENDING
    });
  };
  handleSortByName = () => {
    const newSort = !this.state.nameSortReversed;
    EnterpriseAnalytics.sortsPopinsByName();
    this.setState({
      nameSortReversed: newSort,
      activeSort: newSort ? Sorts.NAME_DESCENDING : Sorts.NAME_ASCENDING
    });
  };
  handleSortByEmail = () => {
    const newSort = !this.state.emailSortReversed;
    EnterpriseAnalytics.sortsPopinsByEmail();
    this.setState({
      emailSortReversed: newSort,
      activeSort: newSort ? Sorts.EMAIL_DESCENDING : Sorts.EMAIL_ASCENDING
    });
  };
  handleSortByUseCase = () => {
    const newSort = !this.state.useCaseSortReversed;
    EnterpriseAnalytics.sortsPopinsByUseCase();
    this.setState({
      useCaseSortReversed: newSort,
      activeSort: newSort ? Sorts.USE_CASE_DESCENDING : Sorts.USE_CASE_ASCENDING
    });
  };
  handleSortByUsers = () => {
    const newSort = !this.state.usersSortReversed;
    EnterpriseAnalytics.sortsPopinsByUsers();
    this.setState({
      usersSortReversed: newSort,
      activeSort: newSort ? Sorts.USERS_DESCENDING : Sorts.USERS_ASCENDING
    });
  };
  handleSortByActivities = () => {
    const newSort = !this.state.activitiesSortReversed;
    EnterpriseAnalytics.sortsPopinsByActivities();
    this.setState({
      activitiesSortReversed: newSort,
      activeSort: newSort ? Sorts.ACTIVITIES_DESCENDING : Sorts.ACTIVITIES_ASCENDING
    });
  };
  formatPopins = (popins) => {
    let popinId = 0;
    return popins.map((popin) => {
      const id = popinId;
      const time = PopinSummary.getStartTime(popin);
      const startTime = (time === null)
        ? 'Not Available'
        : DateTime.format(time, 'MMM D, YYYY');
      const heroName = PopinSummary.getDisplayName(popin);
      const email = PopinSummary.getHeroEmail(popin);
      const useCase = PopinSummary.getUseCase(popin);
      const users = PopinSummary.getUsers(popin);
      const activities = PopinSummary.getActivities(popin);
      popinId++;
      return [id, startTime, heroName, email, useCase, users, activities, popin];
    });
  };
  sortPopins = (popins) => {
    switch (this.state.activeSort) {
      case Sorts.START_TIME_ASCENDING:
        return PopinSorts.copySortedByStartTime(popins);
      case Sorts.START_TIME_DESCENDING:
        return PopinSorts.copySortedByStartTime(popins, true);
      case Sorts.NAME_ASCENDING:
        return PopinSorts.copySortedByName(popins);
      case Sorts.NAME_DESCENDING:
        return PopinSorts.copySortedByName(popins, true);
      case Sorts.EMAIL_ASCENDING:
        return PopinSorts.copySortedByEmail(popins);
      case Sorts.EMAIL_DESCENDING:
        return PopinSorts.copySortedByEmail(popins, true);
      case Sorts.USE_CASE_ASCENDING:
        return PopinSorts.copySortedByUseCase(popins);
      case Sorts.USE_CASE_DESCENDING:
        return PopinSorts.copySortedByUseCase(popins, true);
      case Sorts.USERS_ASCENDING:
        return PopinSorts.copySortedByUsers(popins);
      case Sorts.USERS_DESCENDING:
        return PopinSorts.copySortedByUsers(popins, true);
      case Sorts.ACTIVITIES_ASCENDING:
        return PopinSorts.copySortedByActivities(popins);
      case Sorts.ACTIVITIES_DESCENDING:
        return PopinSorts.copySortedByActivities(popins, true);
      default:
        Logger.assert(`Invalid sort: ${this.state.activeSort}`);
    }
  };
  filterPopins = (popins) => {
    return popSearch.filterArraysOfStrings(popins, this.state.searchTerm);
  };
  getPopins = () => {
    const { popins } = this.props;
    if (popins) {
      const sorted = this.sortPopins(popins);
      const formatted = this.formatPopins(sorted);
      return this.filterPopins(formatted);
    }
  };
  updateSearchFilter = (searchTerm) => {
    // TODO: add timeout
    EnterpriseAnalytics.searchedPopins();
    this.setState({ searchTerm: searchTerm });
  };
  getDivStyle = (img) => {
    const color = '$color-secondary-accent'; //#3D9AE2
    return {
      backgroundImage: 'url(' + img + ')',
      backgroundColor: color
    };
  };

  constructor (props) {
    super(props);

    this.state = {
      activeSort: Sorts.START_TIME_ASCENDING,
      startTimeSortReversed: false,
      nameSortReversed: false,
      emailSortReversed: false,
      useCaseSortReversed: false,
      usersSortReversed: false,
      activitiesSortReversed: false,
      searchTerm: ''
    };
  }

  fetchPopins = () => {
    const { user, fetchPopins, dateRange } = this.props;
    fetchPopins(Tenant.getId(User.getTenant(user)), dateRange.value);
  };

  componentDidMount () {
    this.fetchPopins();
  }

  componentDidUpdate (prevProps) {
    const { dateRange, popinsError } = this.props;
    if (dateRange.value !== prevProps.dateRange.value) {
      this.fetchPopins();
    }

    handleError(popinsError, prevProps.popinsError);
  }

  render () {
    const { searchTerm } = this.state;
    const { popinStatsOverview, dateRange, popinsError, popinsLoading } = this.props;
    const popinsToDisplay = this.getPopins();
    const isStartTimeSortActive = (
      this.state.activeSort === Sorts.START_TIME_ASCENDING ||
      this.state.activeSort === Sorts.START_TIME_DESCENDING
    );
    const isNameSortActive = (
      this.state.activeSort === Sorts.NAME_ASCENDING ||
      this.state.activeSort === Sorts.NAME_DESCENDING
    );
    const isEmailSortActive = (
      this.state.activeSort === Sorts.EMAIL_ASCENDING ||
      this.state.activeSort === Sorts.EMAIL_DESCENDING
    );
    const isUseCaseSortActive = (
      this.state.activeSort === Sorts.USE_CASE_ASCENDING ||
      this.state.activeSort === Sorts.USE_CASE_DESCENDING
    );
    const isUsersSortActive = (
      this.state.activeSort === Sorts.USERS_ASCENDING ||
      this.state.activeSort === Sorts.USERS_DESCENDING
    );
    const isActivitiesSortActive = (
      this.state.activeSort === Sorts.ACTIVITIES_ASCENDING ||
      this.state.activeSort === Sorts.ACTIVITIES_DESCENDING
    );
    return (
      <div className="card analytics-card-height card-popins-breakdown">
        <div className="row fix-ie-when-small">
          <div className="col-lg-8">
            <AnalyticsCardHeader
              customIcon={ this.getDivStyle(popinConvo) }
              count={ popinsLoading
                ? null
                : popinStatsOverview
                  ? popinStatsOverview.active_popins + popinStatsOverview.completed_popins
                  : null }
              title="POPins"
              overview={ popinsLoading ? null : popinStatsOverview }
              dateRange={ dateRange } />
          </div>
          <div className="col-lg-4 clearfix fix-ie">
            <div className="float-right fix-ie">
              <SearchBox updateSearchFilter={ this.updateSearchFilter } />
            </div>
          </div>
        </div>
        <div className="breakdown-table">
          <div className="row breakdown-header breakdown-list-item">
            <div className="start-time">
              <span className="clickable" onClick={ this.handleSortByStartTime }>Start Date</span>
              <i
                onClick={ this.handleSortByStartTime }
                className={ `material-icons clickable ${isStartTimeSortActive
                  ? 'enabled-icon'
                  : 'disabled-icon'}` }>
                { this.state.startTimeSortReversed ? arrowUpIcon : arrowDownIcon }
              </i>
            </div>
            <div className="name">
              <span className="clickable" onClick={ this.handleSortByName }>Name</span>
              <i
                onClick={ this.handleSortByName }
                className={ `material-icons clickable ${isNameSortActive
                  ? 'enabled-icon'
                  : 'disabled-icon'}` }>
                { this.state.nameSortReversed ? arrowUpIcon : arrowDownIcon }
              </i>
            </div>
            <div className="email">
              <span className="clickable" onClick={ this.handleSortByEmail }>Email</span>
              <i
                onClick={ this.handleSortByEmail }
                className={ `material-icons clickable ${isEmailSortActive
                  ? 'enabled-icon'
                  : 'disabled-icon'}` }>
                { this.state.emailSortReversed ? arrowUpIcon : arrowDownIcon }
              </i>
            </div>
            <div className="use-case">
              <span className="clickable" onClick={ this.handleSortByUseCase }>Use Case</span>
              <i
                onClick={ this.handleSortByUseCase }
                className={ `material-icons clickable ${isUseCaseSortActive
                  ? 'enabled-icon'
                  : 'disabled-icon'}` }>
                { this.state.useCaseSortReversed ? arrowUpIcon : arrowDownIcon }
              </i>
            </div>
            <div className="users">
              <Tooltip tooltip="All users who viewed the POPin started by a given POPin Creator.">
                <div className="users">
                  <span className="clickable" onClick={ this.handleSortByUsers }>Users</span>
                  <i
                    onClick={ this.handleSortByUsers }
                    className={ `material-icons clickable ${isUsersSortActive
                      ? 'enabled-icon'
                      : 'disabled-icon'}` }>
                    { this.state.usersSortReversed ? arrowUpIcon : arrowDownIcon }
                  </i>
                </div>
              </Tooltip>
            </div>
            <div className="activities">
              <Tooltip tooltip="An activity is a user view or a user contribution in a POPin started by a given POPin Creator.">
                <div className="activities">
                <span
                  className="clickable"
                  onClick={ this.handleSortByActivities }>Activities</span>
                  <i
                    onClick={ this.handleSortByActivities }
                    className={ `material-icons clickable ${isActivitiesSortActive
                      ? 'enabled-icon'
                      : 'disabled-icon'}` }>
                    { this.state.activitiesSortReversed ? arrowUpIcon : arrowDownIcon }
                  </i>
                </div>
              </Tooltip>
            </div>
          </div>
          { popinsError
            ? <div className="breakdown-list">
              <ErrorAndRefresh error="Failed to load POPins" onRefresh={ this.fetchPopins } />
            </div>
            : popinsLoading
              ? <div className="breakdown-list">
                <LoadingAndPulse
                  size={ 20 }
                  color="#3D9AE2"
                  whatIsLoading="POPins" />
              </div>
              : (popinsToDisplay && popinsToDisplay.length > 0)
                ? (
                  <div className="breakdown-list-container">
                    <div className="col breakdown-list">
                      { popinsToDisplay.map(p => <PopinListItem key={ p[0] } popin={ p } />) }
                    </div>
                  </div>
                ) : searchTerm
                  ? (
                    <div className="breakdown-list">
                      <div className="my-5">
                        <EmptyState
                          image={ null }
                          title="No Search Results"
                          message="Try again with a different search term."
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="breakdown-list">
                      <div className="my-5">
                        <EmptyState
                          image={ EmptyStateIcon }
                          title="No POPins Yet"
                          message="Once a POPin is active you'll see them here."
                        />
                      </div>
                    </div>
                  )
          }
        </div>
      </div>
    );
  }
}

const PopinListItem = ({ popin }) => {
  const startTime = popin[1];
  const name = popin[2];
  const email = popin[3];
  const useCase = popin[4];
  const users = popin[5];
  const activities = popin[6];
  const fullPopin = popin[7];
  const hero = PopinSummary.getHero(fullPopin);
  const delegateCreator = PopinSummary.getDelegateCreator(fullPopin);

  let tooltip;
  if (delegateCreator) {
    tooltip =
      `Creator: ${email}
Delegate: ${User.getEmail(delegateCreator)}
`;
  } else {
    tooltip = null;
  }
  return (
    <div className="row breakdown-list-item list-item py-1">
      <div className="start-time my-auto">{ startTime }</div>
      <div className="name">{ name }</div>
      <div className="email">
        <UserAvatar user={ hero } tooltip={ tooltip } />
      </div>
      <div className="use-case my-auto">{ useCase }</div>
      <div className="users my-auto">{ users }</div>
      <div className="activities my-auto">{ activities }</div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    user: state.user.user,
    popinsLoading: state.tenantStats.popinsLoading,
    popins: state.tenantStats.popins,
    popinStatsOverview: state.tenantStats.popinsOverview,
    popinsError: state.tenantStats.popinsError
  };
};

export default connect(mapStateToProps, { fetchPopins })(PopinsBreakdown);
